(function () {
  const countryStoreMap = {
    GB: 'https://www.weightworld.uk',
    DE: 'https://www.weightworld.de',
    FR: 'https://www.weightworld.fr',
    IT: 'https://www.weightworld.it',
    ES: 'https://www.weightworld.es',
    NL: 'https://www.weightworld.nl',
    SE: 'https://www.weightworld.se',
    DK: 'https://www.weightworld.dk',
    PT: 'https://www.weightworld.com.pt',
    FI: 'https://www.weightworld.fi',
    PL: 'https://www.weightworld.pl',
    IE: 'https://www.weightworld.ie',
  };

  const STORAGE_KEY = 'country-redirect-dismissed';
  const STORAGE_TTL_DAYS = 30;
  const GEO_ENDPOINT = 'https://www.cloudflare.com/cdn-cgi/trace';
  const popup = document.getElementById('country-redirect-popup');
  const title = document.getElementById('country-redirect-popup-title');
  const description = document.querySelector('.country-redirect-popup__description');
  const countryLabel = document.getElementById('country-redirect-popup-country');
  const iconContainer = document.querySelector('.country-redirect-popup__icon');

  if (!popup || !title || !description || !countryLabel || !iconContainer) {
    return;
  }

  function hasRecentDismissal() {
    const storedValue = localStorage.getItem(STORAGE_KEY);

    if (!storedValue) {
      return false;
    }

    try {
      const parsed = JSON.parse(storedValue);
      const expiresAt = parsed.expiresAt || 0;
      return Date.now() < expiresAt;
    } catch (error) {
      return false;
    }
  }

  function rememberDismissal() {
    const expiresAt = Date.now() + STORAGE_TTL_DAYS * 24 * 60 * 60 * 1000;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ expiresAt }));
  }

  function getCountryFlag(countryCode) {
    const flagMap = {
      GB: '🇬🇧',
      DE: '🇩🇪',
      FR: '🇫🇷',
      IT: '🇮🇹',
      ES: '🇪🇸',
      NL: '🇳🇱',
      SE: '🇸🇪',
      DK: '🇩🇰',
      PT: '🇵🇹',
      FI: '🇫🇮',
      PL: '🇵🇱',
      IE: 'IE'
    };

    return flagMap[countryCode] || '🌍';
  }

  function formatCountryLabel(countryCode) {
    const countryNames = {
      GB: 'United Kingdom',
      DE: 'Germany',
      FR: 'France',
      IT: 'Italy',
      ES: 'Spain',
      NL: 'the Netherlands',
      SE: 'Sweden',
      DK: 'Denmark',
      PT: 'Portugal',
      FI: 'Finland',
      PL: 'Poland',
      IE: 'Ireland',
    };

    return countryNames[countryCode] || countryCode;
  }

  function showPopup(countryCode) {
    const redirectUrl = countryStoreMap[countryCode];
    const countryName = formatCountryLabel(countryCode);

    title.textContent = 'Visit your local Weightworld store.';
    countryLabel.textContent = countryName;
    description.textContent = 'Shop with local pricing, shipping, and support in your country.';
    popup.dataset.redirectUrl = redirectUrl;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    enableBackgroundBlock();
  }

  function closePopup() {
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    disableBackgroundBlock();
  }

  function blockDocumentInteractions(event) {
    if (!popup.contains(event.target)) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  function enableBackgroundBlock() {
    document.body.classList.add('country-redirect-open');
    document.addEventListener('click', blockDocumentInteractions, true);
    document.addEventListener('touchstart', blockDocumentInteractions, true);
  }

  function disableBackgroundBlock() {
    document.body.classList.remove('country-redirect-open');
    document.removeEventListener('click', blockDocumentInteractions, true);
    document.removeEventListener('touchstart', blockDocumentInteractions, true);
  }

  async function fetchWithTimeout(url, timeoutMs = 2500) {
    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Cache-Control': 'no-cache',
        },
        signal: controller.signal,
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      return await response.json();
    } finally {
      window.clearTimeout(timeoutId);
    }
  }

  async function detectCountryCode() {
    if (sessionStorage.getItem('country-redirect-blocked')) {
      return null;
    }

    try {
      const response = await fetch(GEO_ENDPOINT, {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      });

      if (response.ok) {
        const text = await response.text();
        const match = text.match(/loc=([A-Z]{2})/i);
        const countryCode = match ? match[1].toUpperCase() : null;
        if (countryStoreMap[countryCode]) {
          return countryCode;
        }
      }

      const fallbackResponse = await fetch('https://ipapi.co/json/', {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Cache-Control': 'no-cache',
        },
      });

      if (!fallbackResponse.ok) {
        return null;
      }

      const fallbackData = await fallbackResponse.json();
      const countryCode = typeof fallbackData?.country === 'string' ? fallbackData.country.toUpperCase() : null;
      return countryStoreMap[countryCode] ? countryCode : null;
    } catch (error) {
      sessionStorage.setItem('country-redirect-blocked', 'true');
      return null;
    }
  }

  popup.addEventListener('click', function (event) {
    event.stopPropagation();

    const target = event.target.closest('[data-action]');

    if (!target) {
      return;
    }

    const action = target.getAttribute('data-action');

    if (action === 'dismiss') {
      rememberDismissal();
      closePopup();
      return;
    }

    if (action === 'redirect') {
      const redirectUrl = popup.dataset.redirectUrl;
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    }
  });

  document.addEventListener('DOMContentLoaded', async function () {
    if (hasRecentDismissal()) {
      return;
    }

    const countryCode = await detectCountryCode();

    if (countryCode) {
      showPopup(countryCode);
    }
  });

  // Prevent click events from bubbling to other apps while popup is open
  popup.addEventListener('mousedown', function (event) {
    event.stopPropagation();
  });
  popup.addEventListener('touchstart', function (event) {
    event.stopPropagation();
  });
})();
